import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import { toast } from "@/lib/toast";
import type { Preset } from "@/types";

export function useSavePreset() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { key: string; label: string; terms: string }) =>
      apiFetch<Preset>("/api/presets", { json: body }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["presets"] });
      toast.success("Пресет сохранён");
    },
    onError: (e: unknown) => {
      const msg = e instanceof Error ? e.message : "Ошибка";
      toast.error(`Не удалось сохранить: ${msg}`);
    },
  });
}

export function useDeletePreset() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => apiFetch(`/api/presets/${key}`, { method: "DELETE" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["presets"] }),
    onError: (e: unknown) => {
      const msg = e instanceof Error ? e.message : "Ошибка";
      toast.error(`Не удалось удалить: ${msg}`);
    },
  });
}
